<template>
  <nav
    class="
      px-4
      py-3
      flex
      items-center
      justify-between
      border-t border-gray-200
      sm:px-6
    "
    aria-label="Pagination"
  >
    <div class="hidden sm:block">
      <p class="text-sm text-gray-700">
        Mostrando
        {{ " " }}
        <span class="font-medium">{{ meta.from }}</span>
        {{ " " }}
        a
        {{ " " }}
        <span class="font-medium">{{ meta.to }}</span>
        {{ " " }}
        de
        {{ " " }}
        <span class="font-medium">{{ meta.total }}</span>
        {{ " " }}
        resultados
      </p>
    </div>
    <div class="flex-1 flex justify-between sm:justify-end">
      <button aria-label="Primera página"
        class="
          btn btn-outline-secondary
          relative
          inline-flex
          items-center
          mx-1
          px-2
          py-1
          my-2
          text-sm
          font-medium
          rounded
          text-gray-700
          disabled:opacity-50 disabled:cursor-auto
        "
        @click="firstPage"
        :disabled="this.page <= 1 || fetching"
      >
        <i aria-hidden="true" class="fas fa-angle-double-left" id="tooltip1audit"></i>
      </button>
      <b-tooltip target="tooltip1audit" placement="bottom">Primera Página</b-tooltip>
      <button aria-label="Anterior"
        class="
          btn btn-outline-primary
          relative
          inline-flex
          items-center
          mx-1
          px-2
          py-1
          my-2
          text-sm
          font-medium
          rounded
          text-gray-700
          disabled:opacity-50 disabled:cursor-auto
        "
        @click="prev"
        :disabled="this.page <= 1 || fetching"
      >
        <i aria-hidden="true" class="fas fa-angle-left" id="tooltip2audit"></i>
      </button>
      <b-tooltip target="tooltip2audit" placement="bottom">Anterior</b-tooltip>
      <button aria-label="Siguiente"
        @click="next"
        class="
          btn btn-outline-primary
          relative
          inline-flex
          items-center
          mx-1
          px-2
          py-1
          my-2
          text-sm
          font-medium
          rounded
          text-gray-700
          disabled:opacity-50 disabled:cursor-auto
        "
        :disabled="this.page >= this.meta.last_page || fetching"
      >
        <i aria-hidden="true" class="fas fa-angle-right" id="tooltip3audit"></i>
      </button>
      <b-tooltip target="tooltip3audit" placement="bottom">Siguiente</b-tooltip>
      <button aria-label="Última página"
        @click="lastPage"
        class="
          btn btn-outline-secondary
          relative
          inline-flex
          items-center
          mx-1
          px-2
          py-1
          my-2
          text-sm
          font-medium
          rounded
          text-gray-700
          disabled:opacity-50 disabled:cursor-auto
        "
        :disabled="this.page >= this.meta.last_page || fetching"
      >
        <i aria-hidden="true" class="fas fa-angle-double-right" id="tooltip4audit"></i>
      </button>
      <b-tooltip target="tooltip4audit" placement="bottom">Última Página</b-tooltip>
    </div>
  </nav>
</template>

<script>
import AuditLogAPI from "@/services/notifications/auditLogAPI";

export default {
  data() {
    return {
      fetching: false,
      meta: {
        from: 0,
        to: 0,
        total: 0,
        current_page: 1,
        last_page: 1,
      },
      page: 1,

      companyID: this.$store.getters["company/getCompany"].id || null,
    };
  },
  created() {
    this.query();
  },
  methods: {
    async query() {
      this.fetching = true;
      try {
        const resp = await AuditLogAPI.getByCompany(this.companyID, this.page);
        const data = resp.AuditLog || null;
        const list = data.data ? data.data : [];

        this.meta = data.meta
          ? {
              from: data.meta.from,
              to: data.meta.to,
              total: data.meta.total,
              current_page: data.meta.current_page,
              last_page: data.meta.last_page,
            }
          : {
              from: data.from || 0,
              to: data.to || 0,
              total: data.total || 0,
              current_page: data.current_page || 1,
              last_page: data.last_page || 1,
            };

        this.$emit("fetch", list);
        this.fetching = false;
        this.$emit("loading", false);
      } catch (error) {
        console.log(error);
        this.fetching = false;
        this.$emit("loading", false);
      }
    },
    firstPage() {
      if (this.page > 1) {
        this.page = 1;
        this.query();
      }
    },
    lastPage() {
      if (this.page < this.meta.last_page) {
        this.page = this.meta.last_page;
        this.query();
      }
    },
    next() {
      if (this.page < this.meta.last_page) {
        this.page++;
        this.query();
      }
    },
    prev() {
      if (this.page > 1) {
        this.page--;
        this.query();
      }
    },
  },
};
</script>
